let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kjq5C")).then(() => parcelRequire('3v762'));